<div class="nav-bar">
  <div class="nav-panel">
    <div class="header-position">
      <div>
        <ukg-button (click)="goToSendPrenoteFile()" data-automation="company_info_back_btn"
          translate emphasis="low" size="medium" parent-icon="go-back"> COMPANIES.BACK_TO_SEND_PRENOTE_SCREEN
        </ukg-button>
      </div>
    </div>
  </div>
  <div>
    <div class="header-position">
      <div class="filter-position">
        <ssg-prenote-history-filters (toggle)="showFilters=$event" style="height: 100%" class="flex-1-0-auto">
        </ssg-prenote-history-filters>
      </div>
    </div>
  </div>
</div>
<div class="display-notification">
  <ssg-notification-bar [userMessages]="userMessages" [notification]="notificationSubject.asObservable()" pageKey="prenote-history" #companyInfoTableNotificationBar></ssg-notification-bar>
</div>

<div style="position: relative;" class="datatable-position">
  <div [ngClass]="{'table-with-filters-container-on': showFilters, 'table-with-filters-container-off': !showFilters }">
    <div class="table-container flex-100">

      <ukg-data-table-container>
        <ukg-data-table [columnNames]="allColumns" is-sortable="true" (ukgDataTableSortChanged)="handleSort($event)" data-automation="prenote-history-table">
          <table id="table">
            <thead id="head">
              <tr>
                <ng-container data-automation="prenote-history-table-column-companyNames">
                  <ukg-th data-automation="prenote-history-table-header-companyNames" sort-key="companyNamesDisplay"
                    sortable>
                    <span data-automation="prenote-history-table-header-companyNames-label" translate>
                      COMPANIES.VIEW_PRENOTE_HISTORY_COLUMN_COMPANY_NAMES</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="prenote-history-table-column-numCompanies">
                  <ukg-th data-automation="prenote-history-table-header-numCompanies" sort-key="numCompanies"
                    sortable>
                    <span data-automation="prenote-history-table-header-numCompanies-label" translate>
                      COMPANIES.VIEW_PRENOTE_HISTORY_COLUMN_COUNT_OF_COMPANIES</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="prenote-history-table-column-userDescription">
                  <ukg-th data-automation="prenote-history-table-header-userDescription" sort-key="userDescription"
                    sortable>
                    <span data-automation="prenote-history-table-header-userDescription-label" translate>
                      COMPANIES.VIEW_PRENOTE_HISTORY_COLUMN_USER</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="prenote-history-table-column-datetimeOfRequest">
                  <ukg-th data-automation="prenote-history-table-header-datetimeOfRequest" sort-key="datetimeOfRequest"
                    sortable initial-sort-direction="desc">
                    <span data-automation="prenote-history-table-header-datetimeOfRequest-label" translate>
                      COMPANIES.VIEW_PRENOTE_HISTORY_COLUMN_DATE_TIME_OF_REQUEST</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="prenote-history-table-column-status">
                  <ukg-th data-automation="prenote-history-table-header-status" sort-key="status"
                    sortable>
                    <span data-automation="prenote-history-table-header-status-label" translate>
                      COMPANIES.VIEW_PRENOTE_HISTORY_COLUMN_STATUS</span>
                  </ukg-th>
                </ng-container>
              </tr>
            </thead>
            <tbody data-automation="data-table-body">
              <ng-container *ngFor="let prenote of records; let i = index">
                <tr data-automation="prenote-history-table-row">
                  <td data-automation="prenote-history-table-companynames">{{ prenote.companyNamesDisplay }}</td>
                  <td data-automation="prenote-history-table-numCompanies">{{ prenote.numCompanies }}</td>
                  <td data-automation="prenote-history-table-userdescription">{{ prenote.userDescription }}</td>
                  <td data-automation="prenote-history-table-datetimeofrequest">{{ prenote.datetimeOfRequest | ultishortdate: 'MM/DD/YYYY hh:mm:ss A':false}}</td>
                  <td data-automation="prenote-history-table-status">{{ prenote.status }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ukg-data-table>
        <ukg-paginator id="paginator" data-automation="paginator" (ukgPageChanged)="onPaginatorChanged($event)"
          [rowsPerPage]="initialRowsPerPage" [totalItems]="dataCount" [rowsOptions]="rowsOptions" translate>
        </ukg-paginator>
      </ukg-data-table-container>

    </div>
  </div>
</div>